import { toast, ToastContent, ToastOptions } from 'react-toastify';

// Opções base + deduplicação: quando o conteúdo é texto, usamos o próprio texto
// como toastId. O react-toastify ignora um toast cujo toastId já está ativo, então
// o MESMO erro disparado duas vezes seguidas (ex.: effects rodando em dobro sob
// React.StrictMode em dev) aparece uma vez só — mas dois erros de textos DIFERENTES
// continuam aparecendo os dois.
const buildOptions = (text: ToastContent): ToastOptions => ({
  position: 'top-center',
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'colored',
  ...(typeof text === 'string' ? { toastId: text } : {}),
});

export const alert = {
  success(text: ToastContent) {
    toast.success(text, buildOptions(text));
  },
  error(text: ToastContent) {
    toast.error(text, buildOptions(text));
  },
  warning(text: ToastContent) {
    toast.warn(text, buildOptions(text));
  },
};
